module.exports = __webpack_public_path__ + "static/media/profImage.0c451804.png";